// extracted by mini-css-extract-plugin
export default {"checkbox":"Todo_checkbox__F2go7"};